export function Alert(prop) {
  var class_name = `alert alert-${prop.type} alert-dismissible fade show`;
  return <div className={class_name}>
    <button type="button" className="close" data-dismiss="alert">&times;</button>
    <strong>{prop.type}</strong> {prop.message}
  </div>
}
